import React from 'react';
import { ArrowUpRight, HeartHandshake } from 'lucide-react';
import Reveal from '../Reveal';

const donateLinkClass =
  'group/d mt-6 inline-flex w-fit items-center gap-2 border-b border-gold-dark/50 pb-1 text-[10px] tracking-[0.28em] text-gold-dark transition-colors duration-300 hover:border-gold-dark hover:text-ink';

const DonateLabel = () => (
  <>
    <HeartHandshake size={13} />
    DONATE TO THE CAUSE
    <ArrowUpRight
      size={11}
      className="transition-transform duration-300 group-hover/d:translate-x-0.5 group-hover/d:-translate-y-0.5"
    />
  </>
);

const DonateAction = ({ cause, onOpen }) => {
  if (cause.donateUrl) {
    return (
      <a href={cause.donateUrl} target="_blank" rel="noopener noreferrer" className={donateLinkClass}>
        <DonateLabel />
      </a>
    );
  }
  return (
    <button onClick={() => onOpen(cause)} className={donateLinkClass}>
      <DonateLabel />
    </button>
  );
};

const CauseCard = ({ cause, onDonate }) => (
  <div className="group flex h-full flex-col">
    <div className="relative overflow-hidden">
      <img
        src={cause.image}
        alt={cause.title}
        loading="lazy"
        className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute left-5 top-5 bg-ink/70 px-3 py-1.5 font-serif text-lg italic text-gold backdrop-blur-sm">
        {cause.num}
      </span>
    </div>
    <h3 className="mt-6 text-[12px] leading-relaxed tracking-[0.22em] text-ink">{cause.title}</h3>
    <div className="mt-3 h-px w-10 bg-gold" />
    <p className="mt-4 flex-1 text-base leading-relaxed text-ink/65">{cause.text}</p>
    <DonateAction cause={cause} onOpen={onDonate} />
  </div>
);

export const CsrCauses = ({ causes, onDonate }) => (
  <section className="bg-cream py-16 md:py-20">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="mb-12 max-w-2xl">
        <Reveal>
          <p className="mb-5 text-[10px] uppercase tracking-[0.5em] text-gold-dark">THREE WAYS TO MAKE AN IMPACT</p>
        </Reveal>
        <Reveal delay={120}>
          <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-[0.03em] text-ink md:text-5xl">
            Causes We Are
            <br />
            Championing
          </h2>
        </Reveal>
      </div>
      <div className="grid gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
        {causes.map((cause, i) => (
          <Reveal key={cause.id} delay={i * 130}>
            <CauseCard cause={cause} onDonate={onDonate} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
